import { css } from "styled-components";

export const RootStyles = css(
    () => css`
        :root {
            --appbar-height: 185px;
        }
    `,
);
